import {createSelector} from "reselect";

const theme = (state) => state.theme;

export const getThemeName = createSelector(theme, (data) => data.name || "");
